// SAA-2026-012 B1.2: cho người dùng biết TRƯỚC khi bấm — vai trò của mình trong dự án và thao tác nào cần vai trò cao hơn.
// Không ẩn / không disable nút (quyết định người dùng 2026-10-22): an toàn nằm ở server, chỗ này chỉ giải thích.
import { useTranslation } from "react-i18next";
import { type ProjectRole, roleMeets, useProject } from "./project-hooks.ts";

/** Nhãn « Vai trò của bạn » + một câu vai trò đó làm được gì. */
export function ProjectRoleBadge({ role }: { role: ProjectRole | null }) {
  const { t } = useTranslation();
  const label = role ? t(`projectMembers.roles.${role}`) : t("access.roleNone");
  return (
    <p className="flex flex-wrap items-center gap-2 text-xs text-(--saa-fg-muted)">
      <span className="rounded-full border border-(--saa-border) bg-(--saa-muted) px-2 py-0.5 font-medium text-(--saa-fg)">{t("access.yourRole", { role: label })}</span>
      <span>{t(`access.roleHelp.${role ?? "none"}`)}</span>
    </p>
  );
}

/** Gợi ý cạnh một thao tác: vai trò hiện tại chưa đủ ⇒ một dòng « cần … — bạn đang là … »; đủ ⇒ không hiện gì. */
export function RoleNeeded({ projectId, needs }: { projectId: string; needs: ProjectRole }) {
  const { t } = useTranslation();
  const project = useProject(projectId);
  if (!project.data) return null;
  const role = project.data.data.myRole;
  if (roleMeets(role, needs)) return null;
  return (
    <p role="note" className="text-xs text-(--saa-fg-muted)">
      {t("access.needsRole", { needs: t(`projectMembers.roles.${needs}`), current: role ? t(`projectMembers.roles.${role}`) : t("access.roleNone") })}
    </p>
  );
}
